'use client';

import { useEffect, useState } from 'react';
import { Toaster } from 'sonner';

/**
 * Defer Sonner mount until after the first client commit.
 *
 * Phase 1 SAH go-live: mounting `<Toaster>` in the root layout during the
 * insertion-effect phase (alongside @dnd-kit / preference hydration) was
 * scheduling React updates and tripping `useInsertionEffect must not schedule
 * updates` on every dashboard route. A one-tick deferral keeps toast delivery
 * unchanged while letting the shell settle first.
 */
export function AppToaster() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <Toaster
      position="top-right"
      toastOptions={{
        style: {
          fontFamily: 'var(--font-space-grotesk)',
        },
      }}
    />
  );
}
